<template>
  <aside class="tracking">
    <!-- Header: buscador + botón expandir -->
    <div class="tracking-title">
      <div class="new-order-side">
        <div class="order-search">
          <label class="sr-only" :for="`orderSearch-${_uid}`">Buscar orden</label>
          <input
            :id="`orderSearch-${_uid}`"
            v-model="search"
            type="text"
            placeholder="Buscar orden…"
          />
        </div>
        <v-badge
          :value="pendientesCount > 0"
          :content="pendientesCount"
          color="red"
          overlap
        >
          <button
            type="button"
            class="expand-orders"
            title="Ver todas las órdenes"
            @click="maximizar()"
          >
            <v-icon small>mdi-arrow-expand-all</v-icon>
          </button>
        </v-badge>
      </div>
    </div>

    <!-- <p class="section-kicker">Órdenes</p>
    <h2>{{ title }}</h2>
    <p class="tracking-sub">
      {{ ordenes_carousel.length }} activa<span v-if="ordenes_carousel.length !== 1">s</span>
      <template v-if="pendientesCount > 0"> · {{ pendientesCount }} con pendientes</template>
    </p> -->

    <!-- Lista -->
    <div class="orders">
      <button
        v-for="orden in ordenesFiltradas"
        :key="orden.intPOSEnc"
        type="button"
        class="order-card"
        :class="[
          `service-${serviceClass(orden)}`,
          { active: orden.intPOSEnc === activeOrderId }
        ]"
        @click="seleccionar(orden)"
      >
        <div class="order-first">
          <strong>
            <v-icon v-if="tienePendientes(orden)" color="yellow" small class="mr-1">
              mdi-bell-ring
            </v-icon>
            {{ "# " + orden.intOrden }}
          </strong>
          <span class="status" :class="statusClass(orden.intEstatus)">
            {{ getEstatus(orden.intEstatus) }}
          </span>
        </div>

        <p class="order-meta">
          {{ getLabel(orden.intPOSTipoServicio) }}
          <template v-if="getTipoVenta(orden.intPOSTipoVenta)">
            · {{ getTipoVenta(orden.intPOSTipoVenta) }}
          </template>
        </p>

        <p v-if="orden.intPOSTipoServicio == 1" class="order-meta">
          {{ orden.strMesa }}
        </p>

        <p v-if="orden.cliente != null" class="order-meta">
          {{ orden.cliente.strNombre }} {{ orden.cliente.strTelefono }}
        </p>

        <p v-if="orden.intPOSTipoServicio == 3" class="order-meta">
          {{ orden.strMesa }}
        </p>

        <p v-if="orden.intPOSTipoServicio == 1" class="order-meta">
          {{ getMesero(orden) }}
        </p>

        <p class="order-meta">{{ toDateString(orden.datFecha, 2) }}</p>

        <p v-if="title == 'Factura'" class="order-meta">
          GUIA {{ orden.strMesa }}
        </p>
      </button>

      <p v-if="!ordenesFiltradas.length" class="order-search-empty">
        Sin resultados
      </p>
    </div>
  
  </aside>
</template>

<script>
import { toDateString } from "../js/utilities";

export default {
  name: "OrdenesCarousel",
  props: {
    principalColor: { type: String },
    ordenes: { type: Array, default: () => [] },
    minOrdenes: { type: Number, default: 5 },
    meseros: { type: Array, default: () => [] },
    // Nuevo, opcional: id de la orden seleccionada en el main
    activeOrderId: { type: [String, Number], default: null },
  },
  data() {
    return {
      title: this.$config.ordenTitle,
      config_37_activo: this.$config.opciones.find((c) => c.id == 37).activo,
      search: "",
    };
  },
  methods: {
    toDateString,

    getLabel(intPOSTipoServicio) {
      if (intPOSTipoServicio == 1) return "MESA";
      else if (intPOSTipoServicio == 2) {
        if (this.title == "Factura") return "";
        else return "DOMICILIO";
      } else if (intPOSTipoServicio == 3) return "MOSTRADOR";
    },
    tienePendientes(orden) {
      const config37 = this.$config.opciones.find((c) => c.id == 37);
      if (!config37 || !config37.activo) return false;
      if (!orden.posDet || !orden.posDet.length) return false;
      return orden.posDet.some((det) => det.intPreparado == null);
    },
    getTipoVenta(intPOSTipoVenta) {
      if (intPOSTipoVenta == 0) return "";
      else if (intPOSTipoVenta == 1) return "RAPPI";
      else if (intPOSTipoVenta == 2) return "UBER";
      else if (intPOSTipoVenta == 3) return "DIDI";
      else if (intPOSTipoVenta == 4) return "COMEDOR";
    },
    maximizar() {
      this.$emit("mostrarordenes");
    },
    seleccionar(orden) {
      this.$emit("seleccionar", orden);
    },
    getImage(orden) {
      if (orden.intPOSTipoServicio == 1) return "//table.jpg";
      else if (orden.intPOSTipoServicio == 2 && orden.intEstatus == 3)
        return "/images/domicilio.jpg";
      else if (orden.intPOSTipoServicio == 3) return "/imagenes/takeaway.jpg";
    },
    getMesero(orden) {
      const mesero = this.meseros.find(
        (mesero) => mesero.intPOSMesero == orden.intPOSMesero
      );
      if (mesero != null) {
        return mesero.strNombre + " " + mesero.strApellidoPaterno;
      } else {
        return "NO ASIGNADO";
      }
    },
    getcolor(orden) {
      if (orden.intPOSTipoServicio == 1) return "primary";
      else if (orden.intPOSTipoServicio == 2) return "green";
      else if (orden.intPOSTipoServicio == 3) return "secondary";
    },
    getEstatus(estatus) {
      const config_21 = this.$config.opciones.find((c) => c.id == 21);
      if (config_21.valor) {
        if (estatus == 1) return "ALTA";
        else if (estatus == 2) return "PAGADA";
        else if (estatus == 3) return "PAGO PARCIAL";
        else if (estatus == 9) return "CANCELADA";
      } else {
        if (estatus == 1) return "REGISTRADA";
        else if (estatus == 2) return "EN COCINA";
        else if (estatus == 3) return "ENVIADA";
        else if (estatus == 4) return "PAGADA";
      }
    },

    // --- Mapeos de clases para el rediseño ---
    serviceClass(orden) {
      if (orden.intPOSTipoServicio == 1) return "table"; // MESA
      if (orden.intPOSTipoServicio == 2) return "home";  // DOMICILIO
      if (orden.intPOSTipoServicio == 3) return "most";  // LLEVAR
      return "table";
    },
    statusClass(estatus) {
      const config_21 = this.$config.opciones.find((c) => c.id == 21);
      if (config_21.valor) {
        if (estatus == 2 || estatus == 3) return "paid";
        if (estatus == 9) return "process";
        return "saved";
      } else {
        if (estatus == 3) return "saved";
        if (estatus == 4) return "paid";
        return "process";
      }
    },
  },
  computed: {
    col_size() {
      return "2";
    },
    pendientesCount() {
      if (!this.config_37_activo) return 0;
      return this.ordenes.filter(
        (orden) =>
          orden.posDet && orden.posDet.some((det) => det.intPreparado == null)
      ).length;
    },
    ordenes_carousel() {
  return this.ordenes
    .filter((orden) => orden.intEstatus !== 4)
    .sort((a, b) => (a.intPOSEnc > b.intPOSEnc ? 1 : -1));
},
    ordenesFiltradas() {
      const q = this.search.trim().toLowerCase();
      if (!q) return this.ordenes_carousel;
      return this.ordenes_carousel.filter((orden) => {
        const numero = String(orden.intOrden ?? "").toLowerCase();
        const mesa = String(orden.strMesa ?? "").toLowerCase();
        const cliente = String(orden.cliente?.strNombre ?? "").toLowerCase();
        return numero.includes(q) || mesa.includes(q) || cliente.includes(q);
      });
    },
  },
};
</script>

<style scoped>
/* ==== Tokens (por si el main no los define globalmente) ==== */
.tracking {
  --primary: #0353a4;
  --primary-hover: #034582;
  --primary-light: #347ea8;
  --primary-tint: #eef5f9;
  --success: #00a63e;
  --success-tint: #e1f5ea;
  --warning: #ffc23c;
  --warning-tint: #fff6df;
  --warning-text: #8a5a00;
  --error: #fb2c36;
  --surface: #fff;
  --surface-alt: #fafbfc;
  --border: #e2e4e8;
  --border-strong: #c7cbd1;
  --text: #1a1d23;
  --muted: #6b7280;
  --r-sm: 8px;
  --r-md: 14px;

  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  box-shadow: 0 3px 12px rgba(17, 29, 45, 0.045);

  min-width: 0;
  min-height: 0;
  padding: 16px 14px;
  display: flex;
  flex-direction: column;
}

/* ==== Encabezado ==== */
.tracking-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 9px;
}
.tracking-title .new-order-side {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 9px;
}
.tracking-title .order-search {
  flex: 1;
  min-width: 0;
}
.order-search input {
  display: block;
  width: 100%;
  height: 46px;
  box-sizing: border-box;
  border: 1.5px solid var(--border-strong);
  border-radius: var(--r-sm);
  background: var(--surface);
  color: var(--text);
  padding: 0 12px;
  font: inherit;
  font-size: 12px;
}
.order-search input::placeholder {
  color: var(--muted);
}
.order-search input:focus,
.order-search input:focus-visible {
  outline: none;
  border: 2.5px solid var(--primary-light);
  box-shadow: 0 0 0 4px rgba(52, 126, 168, 0.18);
}

.expand-orders {
  position: relative;
  width: 40px;
  height: 40px;
  padding: 0;
  flex: none;
  overflow-y: auto;
  border: 1px solid var(--border-strong);
  border-radius: var(--r-sm);
  background: var(--primary-tint);
  color: var(--primary);
  display: grid;
  place-items: center;
  cursor: pointer;
  transition: 0.15s ease;
}
.expand-orders:hover {
  background: #d6e8f1;
  color: var(--primary-hover);
}

.section-kicker {
  font-size: 10px;
  text-transform: uppercase;
  color: var(--muted);
  font-weight: 700;
  letter-spacing: 0.07em;
  margin-bottom: 6px;
}
.tracking h2 {
  font-size: 20px;
  line-height: 1.25;
  letter-spacing: -0.02em;
  margin: 0;
}
.tracking-sub {
  font-size: 11px;
  color: var(--muted);
  margin: 5px 0 12px;
}

/* ==== Lista de órdenes ==== */
.orders {
  overflow-y: auto;
  min-height: 0;
  padding-right: 0;
  scrollbar-width: thin;
}

.order-card {
  min-height: 30px;
  width: 100%;
  display: block;
  text-align: left;
  background: var(--surface);
  border: 1px solid var(--border);
  border-left: 3px solid var(--border);
  border-radius: var(--r-sm);
  padding: 4px 6px;
  margin-bottom: 3px;
  transition: 0.15s ease;
  cursor: pointer;
  font: inherit;
  color: var(--text);
}
.order-card:hover {
  border-color: var(--primary-light);
  filter: none;
}
.order-card.active {
  border-color: var(--primary);
  box-shadow: inset 3px 0 0 var(--primary);
}

.order-first {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  align-items: center;
}
.order-first strong {
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-flex;
  align-items: center;
}
.order-meta {
  font-size: 15px;
  line-height: 1.25;
  color: var(--muted);
  margin: 2px 0 0;
}

/* ==== Colores por tipo de servicio ==== */
.order-card.service-most {
  background: #f58b00;
  color: #fff;
  border-left-color: #f58b00;
}
.order-card.service-home {
  background: #49ae4f;
  color: #fff;
  border-left-color: #49ae4f;
}
.order-card.service-table {
  background: #2196f3;
  color: #fff;
  border-left-color: #2196f3;
}
.order-card.service-most .order-meta,
.order-card.service-home .order-meta,
.order-card.service-table .order-meta {
  color: #fff;
  opacity: 0.92;
}
.order-card.service-most .status,
.order-card.service-home .status,
.order-card.service-table .status {
  background: #fff;
  color: #1a1d23;
}
.order-card.service-most.active,
.order-card.service-home.active,
.order-card.service-table.active {
  outline: 2px solid var(--primary);
  outline-offset: 1px;
  box-shadow: inset 0 0 0 2px #fff;
  opacity: 1;
}

/* ==== Status pill ==== */
.status {
  border-radius: 999px;
  padding: 2px 5px;
  font-size: 8px;
  font-weight: 700;
  white-space: nowrap;
  display: inline-block;
}
.status.process {
  background: var(--warning-tint);
  color: var(--warning-text);
}
.status.saved {
  background: #e7eff8;
  color: #1c3a5c;
}
.status.paid {
  background: var(--success-tint);
  color: #0a6b32;
}

/* ==== Empty ==== */
.order-search-empty {
  padding: 14px 8px;
  color: var(--muted);
  font-size: 12px;
  text-align: center;
}

/* ==== Marca ==== */
.tracking-brand {
  margin-top: auto;
  padding: 20px 0 8px;
  flex: none;
  text-align: center;
}
.tootle-mark {
  font-size: clamp(37px, 3vw, 49px);
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.055em;
  color: var(--primary);
  white-space: nowrap;
}
.tootle-mark b {
  font-weight: 800;
  color: var(--primary);
}

/* ==== Utilidades ==== */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

/* ==== Responsive ==== */
@media (max-width: 980px) {
  .orders {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    overflow-y: hidden;
  }
  .order-card {
    min-width: 185px;
  }
}

@media (min-width: 1500px) {
  .tracking {
    padding: 19px 17px;
  }
  .order-card {
    min-height: 87px;
    padding: 10px 11px;
  }
  .order-first strong {
    font-size: 16px;
  }
  .order-meta {
    font-size: 14px;
    line-height: 1.45;
  }
  .status {
    font-size: 12px;
    padding: 6px 9px;
  }
  .tracking h2 {
    font-size: 22px;
  }
  .tracking-sub,
  .section-kicker {
    font-size: 13px;
  }
}
</style>